export const formatDateToDayMonthYear = (date: string) =>
  date.split('-').reverse().join('/');
